"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putQuoteImage = void 0;
/**
 * Get a presigned S3 url for creating a quote image upload
 */
var putQuoteImage = function (instance) {
    return function (companyCode, fileName, body, config) {
        return instance.put("/quotes/image/".concat(companyCode, "/").concat(fileName), body, config);
    };
};
exports.putQuoteImage = putQuoteImage;
